var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"em-check-wrapper"},[_c('Checkbox',{attrs:{"checked":_vm.isChecked},on:{"update:checked":function($event){_vm.isChecked=$event},"change":_vm.changeStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }